<template>
  <div>
    <div class="flex justify-between mb-4">
      <h2 class="text-2xl font-bold">Custom Parameters</h2>
      <base-button @click="addOpen = !addOpen">
        <span v-if="addOpen">Close</span>
        <span v-else><icon-plus /> Add new parameter</span>
      </base-button>
    </div>

    <AdminSegmentSchemaForm v-if="addOpen" @saved="addOpen = false" />

    <div v-if="fetchingList" class="text-blue-400">
      <base-loading class="block text-3xl" />
      Loading
    </div>
    <base-notice v-else-if="empty" class="my-12">
      No custom parameters were created yet
    </base-notice>
    <draggable
      v-else
      tag="ul"
      v-model="list"
      :animation="150"
      handle=".drag-handle"
      ghost-class="ghost"
      class="my-12"
    >
      <li v-for="schema in list" :key="schema.id">
        <div class="flex bg-white mb-1">
          <button
            class="drag-handle cursor-move p-2 text-gray-500 hover:text-blue-400 focus:outline-none"
          >
            <icon-drag />
          </button>
          <div class="flex-1 flex justify-between py-2 pl-2 pr-4">
            {{ schema.name }}
            <strong>{{ schema.ui_input }}</strong>
          </div>
          <base-button @click="schema.editing = !schema.editing">
            <icon-edit />
          </base-button>
        </div>
        <AdminSegmentSchemaForm
          v-if="schema.editing"
          :schema="schema"
          @saved="schema.editing = false"
        />
      </li>
    </draggable>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AdminSegmentSchemaForm from './components/AdminSegmentSchemaForm';

export default {
  components: {
    AdminSegmentSchemaForm,
  },
  data() {
    return {
      addOpen: false,
    };
  },
  computed: {
    list: {
      get() {
        return this.$store.state.company.segment.schema.list;
      },
      set(list) {
        this.$store.dispatch('company/segment/schema/updateSchemaOrder', list);
      },
    },
    ...mapState('company/segment/schema', ['fetchingList']),
    ...mapGetters('company/segment/schema', ['empty']),
  },
};
</script>
